export interface OrderTotals {
  subtotalCents: number;
  shippingCents: number;
  vatRate: number;
  vatCents: number;
  totalCents: number;
}

export interface TotalsInput {
  lineTotals: number[];
  hasPhysical: boolean;
  flatShippingCents: number;
  vatRate: number;
}

export function computeTotals(input: TotalsInput): OrderTotals {
  const { lineTotals, hasPhysical, flatShippingCents, vatRate } = input;
  const subtotalCents = lineTotals.reduce((sum, n) => sum + n, 0);
  const shippingCents = hasPhysical ? flatShippingCents : 0;
  const totalCents = subtotalCents + shippingCents;
  const vatCents =
    vatRate === 0 ? 0 : Math.round(totalCents - totalCents / (1 + vatRate));
  return { subtotalCents, shippingCents, vatRate, vatCents, totalCents };
}

export function formatPrice(cents: number, locale: string): string {
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: "EUR",
  }).format(cents / 100);
}
